/**
 * An easy place to store global variables.
 * This is outside of React -- so edits to this object will not trigger a re-render.
 *
 * When to use:
 * - Variables that are used in many places.
 * - Anytime you're basically writing a global variable in disguise -- then this will be clearer and simpler.
 *
 * When to avoid:
 * - Variables that change often, and react re-renders are needed.
 * - Local state and passing props is preferred where it makes sense.
 *
 * Do document any global variables, with a variable delcaration below and a short comment.
 */
class Global {
  /**
	 * Access token for the current user. Set by the AuthProvider when getAccessTokenSilently() is called. 
	 * Used by axios via an interceptor.
	 * Assumes: login/logout is handled by AuthProvider within React.
	 * 
	 * For API calls made on first render, use:
	    import { useAuth } from "context";
	 	const { getAccessTokenSilently } = useAuth();
	  	getAccessTokenSilently().then(...);
	 * @type {string}
	 */
  accessToken;

  /**
   * Organization-level roles
   * @type {string[]}
   */
  roles;

  /**
   * For filter-by-question-list (which can overrun what a url-param can do).
   * @type {{label: string, ids: string[]}}
   */
  questionIdsFilter;

  /**
   * Organization modules - used to determine which modules are available for the current organization.
   * @type {string[]}
   */
  organizationModules;
}

const GLOBAL = new Global();

/**
 * Sets a global variable
 * @param {string} key
 * @param {any} value
 */
export function setGlobal(key, value) {
  // console.log("setGlobal",key,value);
  GLOBAL[key] = value;
}

export default GLOBAL;
